// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-upload {
  width: 150px !important;
  height: 150px !important;
  min-width: auto !important;
  border: 1px solid gray;
  position: relative;
}

.image-preview {
  position: absolute;
  width: 150px;
  height: 150px;
}
.image-preview img {
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Production/shared/components/ImageUpload.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".image-upload {\n  width: 150px !important;\n  height: 150px !important;\n  min-width: auto !important;\n  border: 1px solid gray;\n  position: relative;\n}\n\n.image-preview {\n  position: absolute;\n  width: 150px;\n  height: 150px;\n}\n.image-preview img {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
